import React from 'react';
import HeaderDashboard from '../Components/HeaderDashboard'

const Dashboard = () => (
	<>
		<HeaderDashboard></HeaderDashboard>
		<div className="toolbar py-2" id="kt_toolbar">
			<div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
				<div className="flex-grow-1 flex-shrink-0 me-5">
					<div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
						<h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Dashboard</h1>
						<span className="h-20px border-gray-200 border-start mx-3"></span>
						<ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
							<li className="breadcrumb-item">
								<a href="/Settings/Bands" className="text-muted text-hover-primary">Dashboard</a>
							</li>

						</ul>
					</div>
				</div>

			</div>
		</div>

		<section className='wraper'>
			<div className='box_shadow_d mt-16'>

				<div id="kt_content_container" >
					<div class="row">
						<div class="col-xl-3">
							<a href="#" class="card bg-info hoverable card-xl-stretch mb-5">
								<div class="card-body">
									<div class="nry">603</div>
									<img src="/assets/images/circle.png" alt="circle" class="card-img-absolute" />
									<i class="fa fa-plane text-white fs-2x ms-n1"></i>
									<div class="text-white fw-bold fs-2 mb-2 mt-5">Flight</div>
								</div>
							</a>
						</div>
						<div class="col-xl-3">
							<a href="#" class="card bg-dark hoverable card-xl-stretch mb-5">
								<div class="card-body">
									<div class="nry">423</div>
									<img src="/assets/images/circle.png" alt="circle" class="card-img-absolute" />
									<i class="fa fa-hotel text-gray-100 fs-2x ms-n1"></i>
									<div class="text-gray-100 fw-bold fs-2 mb-2 mt-5">Hotel</div>
								</div>
							</a>
						</div>
						<div class="col-xl-3">
							<a href="#" class="card bg-warning hoverable card-xl-stretch mb-5">
								<div class="card-body">
									<div class="nry">223</div>
									<img src="/assets/images/circle.png" alt="circle" class="card-img-absolute" />
									<i class="fa fa-bus text-white fs-2x ms-n1"></i>
									<div class="text-white fw-bold fs-2 mb-2 mt-5">Bus</div>
								</div>
							</a>
						</div>
						<div class="col-xl-3">
							<a href="#" class="card bg-primary hoverable card-xl-stretch mb-5">
								<div class="card-body">
									<div class="nry">42</div>
									<img src="/assets/images/circle.png" alt="circle" class="card-img-absolute" />
									<i class="fa fa-car text-white fs-2x ms-n1"></i>
									<div class="text-white fw-bold fs-2 mb-2 mt-5">Cabs</div>
								</div>
							</a>
						</div>
						<div class="col-xl-3">
							<a href="#" class="card bg-success hoverable card-xl-stretch mb-5">
								<div class="card-body">
									<div class="nry">23</div>
									<img src="/assets/images/circle.png" alt="circle" class="card-img-absolute" />
									<i class="fa fa-address-card text-white fs-2x ms-n1"></i>
									<div class="text-white fw-bold fs-2 mb-2 mt-5">Visa</div>
								</div>
							</a>
						</div>
						<div class="col-xl-3">
							<a href="#" class="card bg-danger hoverable card-xl-stretch mb-5">
								<div class="card-body">
									<div class="nry">523</div>
									<img src="/assets/images/circle.png" alt="circle" class="card-img-absolute" />
									<i class="fa fa-comments-dollar text-white fs-2x ms-n1"></i>
									<div class="text-white fw-bold fs-2 mb-2 mt-5">Forex</div>
								</div>
							</a>
						</div>
						<div class="col-xl-3">
							<a href="#" class="card bg-primary-subtle hoverable card-xl-stretch mb-5">
								<div class="card-body">
									<div class="nry">223</div>
									<img src="/assets/images/circle.png" alt="circle" class="card-img-absolute" />
									<i class="fa fa-umbrella text-primary-emphasis fs-2x ms-n1"></i>
									<div class="text-primary-emphasis fw-bold fs-2 mb-2 mt-5">Insurance</div>
								</div>
							</a>
						</div>
						<div class="col-xl-3">
							<a href="#" class="card bg-success-subtle hoverable card-xl-stretch mb-5">
								<div class="card-body">
									<div class="nry">123</div>
									<img src="/assets/images/circle.png" alt="circle" class="card-img-absolute" />
									<i class="fa fa-train text-success-emphasis fs-2x ms-n1"></i>
									<div class="text-success-emphasis fw-bold fs-2 mb-2 mt-5">Rail</div>
								</div>
							</a>
						</div>


					</div>

				</div>
			</div>
		</section>
	</>
);

export default Dashboard;